import qs from "query-string";

import { httpClient } from "../../core/utils/httpClient";
import { httpClient2 } from "modules/core/utils/httpClient2";

import { IUpdateProjectDetailsDto, UserLocalProjectsDto } from "../types/dto";

import { IAccountProjectsResponse } from "../types/res";
import { IProject, IRollups } from "../types/entities";

// All projects in current subdomain (including projects that user has no access to)
export const fetchAccountProjects = async () => {
  const response = await httpClient.get<IAccountProjectsResponse>(
    "/users_management/projects"
  );

  return response.data;
};

// All projects in current subdomain that user can access
export const fetchUserLocalProjects = async (
  params: UserLocalProjectsDto = {}
) => {
  const response = await httpClient.get<IProject[]>(
    "/projects/user_local_projects",
    { params }
  );

  return response.data;
};

export const fetchRollups = async (includeArchived?: boolean) => {
  const response = await httpClient2.get<IRollups>(
    "/project_groups/rollup_list",
    {
      params: { archived: includeArchived },
      paramsSerializer: providedParams => {
        return qs.stringify(providedParams, {
          arrayFormat: "bracket",
          skipEmptyString: true,
          skipNull: true
        });
      }
    }
  );

  return response.data;
};

export const toggleProjectArchive = async ({
  project_id
}: {
  project_id: string;
}) => {
  const response = await httpClient.put(
    `/projects/${project_id}/toggle_archived`
  );

  return response.data;
};

export const deleteProject = async ({ project_id }: { project_id: string }) => {
  const response = await httpClient.delete(`/projects/${project_id}`);

  return response.data;
};

export const updateProjectDetails = async (args: {
  project_id: string;
  dto: IUpdateProjectDetailsDto;
}) => {
  const response = await httpClient2.put(
    `/projects/${args.project_id}`,
    args.dto
  );

  return response.data;
};
